<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import { animations } from './assets/js/animations'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  methods: {
    posterAnimation () {
      const app = document.getElementById('app')
      document.onmousemove = (function () {
        var onmousestop = function () {
          app.classList.remove('mousemove')
        }
        var thread
        return function () {
          app.classList.add('mousemove')
          clearTimeout(thread)
          thread = setTimeout(onmousestop, 1000)
        }
      })()
    }
  },
  mounted () {
    animations(this.$scrollmagic)
    // this.posterAnimation()
  }
}
</script>

<style lang="scss">
@import './assets/scss/app';
#app{
  transition: all 0.3s ease-in-out;
  border: 2rem solid transparent;
}
#app.mousemove{
  border: 2rem solid #00000080;
  transition: all 0.3s ease-in-out;
}

@media screen and (max-widht: 600px){
  #app{
    border: 1rem solid transparent;
  }
}
</style>
